const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Get workflows', () => {
  describe('get workflow definitions from source and target', () => {
    const mock = loadRecordedMock('get_workflows_preview.json');

    const workflows = jpath('..workflows', mock.response)?.flat() || [];
    let source = [0, ''];
    let target = [0, ''];

    Object.entries(mock.response).map(([alias, projects], i) =>
      // eslint-disable-next-line no-unused-vars
      Object.entries(projects).map(([projectId, projectData]) => {
        const length = projectData.workflows?.length || 0;
        if (i) {
          target = [length, alias];
        } else {
          source = [length, alias];
        }
      })
    );

    it(`should return ${workflows.length} workflows, ${source[0]} in ${source[1]} and ${target[0]} in ${target[1]}`, (done) => {
      migratortronApi.post(
        'get/workflows',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          const workflows = jpath('..workflows', body)?.flat() || [];
          expect(workflows?.length).to.be.greaterThan(0);

          Object.entries(body).map(([alias, projects]) =>
            Object.entries(projects).map(([projectId, projectData]) => {
              const length = projectData.workflows?.length || 0;
              console.log(`${length} workflows in ${projectId} on ${alias}`);
              expect(length).to.be.greaterThan(0);
            })
          );

          done(error);
        }
      );
    });
  });
});
